import styled from "styled-components";
import ToggleButtonGroup from "@material-ui/lab/ToggleButtonGroup";
import ToggleButton from "@material-ui/lab/ToggleButton";

import { breakpoints, colors, easingSeconds } from "../";

export const SearchTypeToggleGroup = styled(ToggleButtonGroup)`
    && {
        background: ${colors.emptySearchBG};
        border-radius: 0;
        padding: 1.25rem 1.5rem; /* 20px 24px */
    }
`;

export const SearchTypeToggleButton = styled(ToggleButton)`
    &&,
    &.MuiToggleButtonGroup-groupedHorizontal:not(:last-child),
    &.MuiToggleButtonGroup-groupedHorizontal:not(:first-child) {
        text-transform: none;
        font-size: 0.75rem; /* 12px */
        line-height: 0.75rem; /* 12px */
        font-family: inherit;
        font-weight: normal;
        padding: 0.5rem 1.125rem; /* 8px 18px */
        height: 1.75rem; /* 28px */
        color: ${colors.dark};
        background: transparent;
        border: 1px solid ${colors.veryLightPinkThree};
        border-radius: 1rem; /* 16px */
        transition: all ${easingSeconds};

        &:first-of-type {
            margin-right: 1rem; /* 16px */
        }

        &.Mui-selected,
        &:hover {
            border-color: transparent;
            color: ${colors.emptySearchBG};
            background: ${colors.dark};
        }

        &.MuiToggleButtonGroup-groupedHorizontal:not(:first-child) {
            /* turn off negative left margin that is default: */
            margin-left: 0;
        }
    }
`;
